(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locked"] && !Shopify.designMode) return;
  try {
    
  var contactContainer = document.querySelector('.lock-page__contact');
  var contactForm = document.querySelector('.lock-page__contact .lock-page__contact--form');

  document.getElementById('contact-form-initiator').addEventListener('click', function() {
    contactForm.classList.toggle('active');
  });

  contactContainer.querySelector('.close').addEventListener('click', function() {
    contactForm.classList.remove('active');
  });

  } catch(e) { console.error(e); }
})();
})();
